export const enum EPaymentInitSource {
  /** Рекомендованный пакет */
  LkRealtorPackage = 'packageLkRealtor',
  /** Конструктор  */
  LkRealtorCustomPackage = 'customPackageLkRealtor',
  /** Подписка  */
  LkRealtorSubscription = 'subscriptionLkRealtor',
  /** Персональный пакет */
  LkRealtorPersonalPackage = 'personalPackageLkRealtor',
  /** Персональная подписка  */
  LkRealtorPersonalSubscription = 'personalSubscriptionLkRealtor',
  /** Смарт-пакет  */
  LkRealtorSmartPackage = 'smartPackageLkRealtor',
  /** Пополнение в сайд-баре лк соба  */
  LkOwnerDeposit = 'depositLkHomeowner',
  /** Пополнение в лк риелтора  */
  LkRealtorDeposit = 'depositLkRealtor',
  /** Платёж для идентификации по карте в лк соба */
  LkOwnerIdentification = 'lkHomeownerIdentification',
  /** Платёж для идентификации по карте в лк риелтора */
  LkRealtorIdentification = 'identificationLkRealtor',
  /** Платёж для идентификации по карте на ФП */
  AddFormIdentification = 'publishObjectIdentification',
  /** Пополнение на форме подачи */
  AddFormDeposit = 'publishObject',
}
